<template>
  <div class="page-selection">
    <button v-if="currentPage !== 1" @click="$emit('change', currentPage - 1)">
      <v-icon>mdi-chevron-left</v-icon>
    </button>
    <template v-if="nearbyPages[0] != 1">
      <button @click="$emit('change', 1)">1</button>
      <span>...</span>
    </template>

    <button
      v-for="pageNumber in nearbyPages"
      v-bind:key="pageNumber"
      @click="$emit('change', pageNumber)"
      :class="{ 'active-page': pageNumber === currentPage }"
      :disabled="pageNumber === currentPage"
    >
      {{ pageNumber }}
    </button>

    <template v-if="nearbyPages[nearbyPages.length - 1] != totalPages">
      <span>...</span>
      <button @click="$emit('change', totalPages)">{{ totalPages }}</button>
    </template>
    <button v-if="currentPage !== totalPages" @click="$emit('change', currentPage + 1)">
      <v-icon>mdi-chevron-right</v-icon>
    </button>
  </div>
</template>

<script>
export default {
  name: "page-selection",

  model: {
    prop: "currentPage",
    event: "change",
  },

  props: {
    totalPages: Number,
    maxDisplayed: {
      type: Number,
      default: 7,
    },
    currentPage: Number, // Should be the default v-model
  },

  computed: {
    nearbyPages() {
      const startPage = Math.max(1, this.currentPage - 2);
      const endPage = Math.min(this.currentPage + 2, this.totalPages);
      let pages = [];
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
};
</script>

<style scoped>
.page-selection {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;

  text-align: center;

  color: var(--text-middle-lightness);
}

.page-selection button:disabled {
  color: var(--text-maximum-lightness);
  text-decoration: underline;
}
</style>
